// Haptic feedback utility for mobile devices
// Uses the Vibration API (supported on Android, not iOS Safari)

type HapticPattern = 'light' | 'medium' | 'heavy' | 'success' | 'error' | 'warning';

const patterns: Record<HapticPattern, number | number[]> = {
  light: 10,
  medium: 25,
  heavy: 50,
  success: [10, 50, 10],
  error: [50, 30, 50],
  warning: [25, 50, 25, 50],
};

export const haptic = (pattern: HapticPattern = 'light'): void => {
  // Check if vibration API is available
  if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
    try {
      navigator.vibrate(patterns[pattern]);
    } catch {
      // Silently fail if vibration is not supported
    }
  }
};

export const hapticOnClick = <T extends (...args: unknown[]) => unknown>(
  callback?: T,
  pattern: HapticPattern = 'light'
) => {
  return (...args: Parameters<T>) => {
    haptic(pattern);
    return callback?.(...args);
  };
};
